module.exports = "<div class=\"not-found\">\r\n\t<img src=\"/assets/resources/img/404.png\" class=\"\">\r\n\t<p class=\"text-center bold margin-top-20 color-dark-sky-blue cursor-pointer\" (click)=\"onHome()\">Return to Home</p>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pagenotfound/pagenotfound.component.html
// module id = ./src/app/pagenotfound/pagenotfound.component.html
// module chunks = main